import { ConfigurationPanel } from "../..";
import { OwnerInformation } from "./ownerInformation";
import { GeneralSchedule } from "./generalSchedule";
import { CurrencyShop } from "./currencyShop";
import { ShopInformation } from "./shopInformation";
import { Maintenance } from "./maintenance";
import "./reference.css";
export const GeneralInformation = () => (
  <div className="generalInformationReference">
    <ConfigurationPanel
      title="Información de la tienda"
      description="Datos del negocio que aparecen en la tienda, en los tickets y en las facturas."
      className="generalReferenceCard configurationShopPanel"
      content={<ShopInformation />}
      hasButtonSave={false}
    />
    <ConfigurationPanel
      title="Horario"
      description="Horario de referencia del negocio, festivos y fechas especiales."
      className="generalReferenceCard"
      content={<GeneralSchedule />}
      hasButtonSave={false}
    />
    <ConfigurationPanel
      title="Información del propietario"
      description="Titular del negocio y su contacto directo."
      className="generalReferenceCard"
      content={<OwnerInformation />}
      hasButtonSave={false}
    />
    <div className="generalBottomCards">
      <ConfigurationPanel
        title="Moneda"
        description="Moneda con la que se muestran los precios en la tienda y en el TPV."
        className="generalReferenceCard"
        content={<CurrencyShop />}
        hasButtonSave={false}
      />
      <ConfigurationPanel
        title="Mantenimiento"
        description="Corte temporal de los pedidos de la tienda online."
        className="generalReferenceCard"
        content={<Maintenance />}
        hasButtonSave={false}
      />
    </div>
  </div>
);
